import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThirdPartySamlSignatureComponent } from './third-party-saml-signature/third-party-saml-signature.component';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ThirdPartySamlSearchComponent } from './third-party-saml-search/third-party-saml-search.component';
import { ThirdPartySamlRoutingModule } from './third-party-saml-routing.module';

@NgModule({
  declarations: [ThirdPartySamlSignatureComponent, ThirdPartySamlSearchComponent],
  imports: [CommonModule, ThirdPartySamlRoutingModule, MaterialModule, TranslateModule, ReactiveFormsModule],
})
export class ThirdPartySamlModule {}
